<div class="backDrop" *ngIf="showDialog">
	<div class="modal-dialog modal-xl">
		<div class="modal-content ">
			<div>
				<!-- Modal Header -->
				<div class="modal-header ">
					<h4 class="modal-title">Edit: {{ title }}</h4>
				</div>

				<!-- Modal body -->
				<div class="modal-body ">
					<!--inhoud-->
					<dx-html-editor height="200px" [value]="content">
						<dxo-toolbar>
							<dxi-item name="undo"></dxi-item>
							<dxi-item name="redo"></dxi-item>
							<dxi-item name="separator"></dxi-item>
							<dxi-item name="size" [acceptedValues]="['8pt', '10pt', '12pt', '14pt', '18pt', '24pt', '36pt']"></dxi-item>
							<dxi-item name="font"
								[acceptedValues]="['Arial', 'Courier New', 'Georgia', 'Impact', 'Lucida Console', 'Tahoma', 'Times New Roman', 'Verdana']">
							</dxi-item>
							<dxi-item name="separator"></dxi-item>
							<dxi-item name="bold"></dxi-item>
							<dxi-item name="italic"></dxi-item>
							<dxi-item name="strike"></dxi-item>
							<dxi-item name="underline"></dxi-item>
							<dxi-item name="separator"></dxi-item>
							<dxi-item name="alignLeft"></dxi-item>
							<dxi-item name="alignCenter"></dxi-item>
							<dxi-item name="alignRight"></dxi-item>
							<dxi-item name="alignJustify"></dxi-item>
							<dxi-item name="separator"></dxi-item>
							<dxi-item name="orderedList"></dxi-item>
							<dxi-item name="bulletList"></dxi-item>
							<dxi-item name="separator"></dxi-item>
							<dxi-item name="header" [acceptedValues]="[false, 1, 2, 3, 4, 5]"></dxi-item>
							<dxi-item name="separator"></dxi-item>
							<dxi-item name="color"></dxi-item>
							<dxi-item name="background"></dxi-item>
							<dxi-item name="separator"></dxi-item>
							<dxi-item name="link"></dxi-item>
							<dxi-item name="image"></dxi-item>
							<dxi-item name="separator"></dxi-item>
							<dxi-item name="clear"></dxi-item>
							<dxi-item name="codeBlock"></dxi-item>
							<dxi-item name="blockquote"></dxi-item>
						</dxo-toolbar>
						<dxo-media-resizing [enabled]=true>
						</dxo-media-resizing>
					</dx-html-editor>
				</div>

				<!-- Modal footer -->
				<div class="modal-footer">
					<button type="button" class="btn btn-success" (click)="save()">
						Save
					</button>
					<button type="button" class="btn btn-primary" (click)="cancel()">
						Cancel
					</button>
				</div>
			</div>
		</div>
	</div>
</div>
